<template lang="pug">
section.section.main-content
  .container
    .columns
      .column.is-two-thirds
        //.o-container
        .div.title-wrapper
          .column.title-column
            div.title-status-wrapper
              h3.title.is-3.title-detail Cotización \#{{ product.code }}
              .tag(:class="getStatusClass(product.status)") {{product.status_detail && product.status_detail.metastate_name }}
            .assigned(v-if="fetchIsTechnical && !broker") Técnico asignado: {{ product.assigned_technical }}
            .box-wrapper(v-if="( product.status == 4 || product.status == 5 ) && !broker")
              .title-rejection Cotización {{product.status_detail.status_name}} por {{product.status_detail.sender_inbox_name}}
              .reason-title MOTIVO
              div(class="description-wrapper")
                .reason(v-if="product.status_detail.reason") {{product.status_detail.reason.description}}
                .comment(v-if="product.status_detail.comment") {{ product.status_detail.comment.text }}
              .footer-reason
                .user {{product.status_detail.user.full_name}}
                .time {{dateRejection}}
            div.subtitle DATOS DE LA COTIZACIÓN
        .select-form(v-if="product.quotation")
          form(v-on:submit.prevent, ref="formDetail")
            .broker-assigned(v-if="product.quotation.broker_business") BROKER
              div {{ product.quotation.broker_business.name }}
            .c-form
              .c-form__form-row.c-form__form-row--full
                label.c-form__form-label ¿Es un consorcio?
                label.c-form__form-label {{ isPartnership }}
              .c-form__form-row
                label.c-form__form-label(for="contractor") CONTRATANTE (*)
                input#contractor.c-form__form-input(
                  name="contractor",
                  type="text",
                  v-model="product.quotation.client",
                  readonly
                )
              .c-form__form-row
                label.c-form__form-label(for="ruc") RUC/DNI&nbsp;
                  span(v-if="!!!product.quotation.is_partnership") (*)
                input#ruc.c-form__form-input(
                  name="ruc",
                  type="text",
                  v-model="product.quotation.document_code",
                  :required="!!product.quotation.is_partnership",
                  readonly
                )
              .c-form__form-row
                label.c-form__form-label(for="turn") GIRO (*)
                input#turn.c-form__form-input(
                  name="turn",
                  type="text",
                  v-model="product.quotation.turn_name",
                  readonly
                )
                strong.other-quotation(v-if="product.quotation.turn_description !==''") Descripcion: {{ product.quotation.turn_description }}
              .c-form__form-row
                label.c-form__form-label(for="activity") DETALLE DE ACTIVIDAD
                input#activity.c-form__form-input(
                  name="activity",
                  type="text",
                  v-model="product.quotation.activity",
                  readonly
                )
              .wrapper(v-if="!broker") 
                .subtitle-wrapper
                  label GESTIONES ADICIONALES
                .checkbox-wrapper
                  b-checkbox(
                    :ref="additionalManagement.name",
                    v-model="additionalManagementSelected",
                    :native-value="additionalManagement.id",
                    @input="changeCheckbox(additionalManagement.id, additionalManagement.name)",
                    v-for="additionalManagement in additionalManagementList",
                    :disabled="managementsDisabled"
                  ) {{ additionalManagement.name }}
              .c-form__form-row.c-form__form-row--full
                //label.c-form__form-label(v-if="product.name == 'Programa estratégico (Multiriesgo/RC/3D)'") PROGRAMA ESTRATÉGICO: {{ product.technical_team_info.team_bag.name }}
                //label.c-form__form-label(v-else-if="product.name == 'Programa estratégico (Multiriesgo/RC/3D)COPY'") PROGRAMA ESTRATÉGICO: {{ product.technical_team_info.team_bag.name }}
                label.c-form__form-label(v-if="product.name == 'Programa estratégico (Multiriesgo/RC/3D)'") Programa estratégico: Responsabilidad Civil, Deshonestidad, 3D y Robo
                label.c-form__form-label(v-else-if="product.name == 'Programa estratégico (Multiriesgo/RC/3D)COPY'") Programa estratégico: Multiriesgo e Incendio
                label.c-form__form-label(v-else) PRODUCTO {{ product.name }}
                ul.product-list
                  li
                    .product-detail
                      .columns
                        .column
                          .product-detail-cell(
                            v-for="field in product.values",
                            v-if="field.field_type != 'multifile' && field.field_type != 'file' && field.field_type != 'money2' && field.field_type != 'switch' && field.field_type != 'technical' && field.field_type != 'rate'"
                          )
                            p.heading {{ field.name }}
                            p.value {{ parseFieldValue(field) }}
                          .product-detail-cell(
                            v-for="field in product.values",
                            v-if="field.field_type == 'rate'"
                          )
                            p.heading {{field.name.split("(")[0]}}
                            p.value {{ parseFieldValue(field) }} 
                          .product-detail-cell(
                            v-for="field in product.values",
                            v-if="field.field_type == 'money2'"
                          )
                            p.heading {{ field.name }}
                            p.value {{ `$ ${field.money_value}` }}
                        .column
                          .product-detail-cell(
                            v-for="field in product.values",
                            v-if="isMultifileField(field)"
                          )
                            p.heading {{ field.name }}
                            a.document(
                              v-for="attachment in field.attachments"
                              @click="downloadFile(attachment)",
                              target="_blank",
                              :title="attachment.name"
                            ) {{ showFileName(attachment.name) }}
                        .column
                          .product-detail-cell(
                            v-for="field in product.values",
                            v-if="isFileField(field)"
                          )
                            p.heading {{ field.name }}
                            a.document(
                              v-for="attachment in field.attachments"
                              @click="downloadFile(attachment)",
                              target="_blank",
                              :title="attachment.name"
                            ) {{ showFileName(attachment.name) }}
              .c-form__form-row.c-form__form-row--full
                app-comments-viewer(
                  :comments="product.history",
                  @forward="showModal",
                  :filteredTags="filteredTags",
                  :idQuotation="idQuotation"
                )
                comments-requotes(
                  :comments="product.history",
                  @forward="showModal",
                  :filteredTags="filteredTags",
                  :idQuotation="idQuotation"
                )
          reallocation(
            @reallocationSuccess="successReallocation",
            :teamList="filteredTags.data",
            :quotation_id="idQuotation",
            :owner="product.owner",
            v-if="!roleEmission"
          )
          form(v-on:submit.prevent)
            quotation-actions(
              :currentInbox="currentInbox",
              :status="parseInt(product.status)",
              :tecnicaQuotation="tecnicaQuotation",
              :technicalGaveBack="product.is_technical"
              :hasTechnicalQuote="product.has_technical_quote"
              @accept="handleAccept",
              @reject="handleReject",
              @technicalReject="handleTechnicalReject",
              @desist="handleDesist",
              @derive="handleDerive",
              @reply="handleReply",
              @quote="handleQuote",
              @requote="handleRequote"
              @quoteTecnica="handleQuoteTecnica",
              @comment="handleComment",
              @forward="showModal",
              @replyBroker="handleReplyBroker",
              @replyExecutive="handleReplyExecutive"
              @changeActionButton="changeActionButton"
            )
            div(class="subtitle-suscriptor" v-if="showSubtitleSuscriptor") Ingresa la información necesaria (*) para enviar la cotización
            comment-box(
              :type="replyType",
              :reply.sync="replyForm",
              :isStrategic.sync="isStrategic",
              v-if="isCommentActive",
              @sendReply="handleSendReply",
              @handleSuscriptorSelect="handleSuscriptorSelect"
              :status="product.status",
              :strategicField="strategicField",
              :submitButton="submitButton"
              :labelTextArea="labelTextAreaCommentBox"
              :isValidatedStrategic="isValidatedStrategic"
              :fetchIsTechnical="fetchIsTechnical"
              :fetchSelectAssigneeActive="product.technical_team_info.select_assignee_active"
              :fetchDerivationType="product.technical_team_info.team_bag.technical_config.derivation_type"
              :technicalStrategicList="technicalStrategicList"
              :fetchIdSoatVehicular="product.technical_team_info.team_bag.id"
              :currentAction="actionActive"
              :dropFiles="dropFiles"
              @tasa="getTasa"
              @prima="getPrima"
              :isPrimaActive="isPrimaActive"
              :teamBagName="product.technical_team_info.team_bag.name"
            )
            reasons-rejection(
              v-if="showRejectForm"
              :listReasons="listRejectReasons"
              :action="actionActive"
              :quotationId="idQuotation"
            )
            reasons-requote(
              v-if="showRequoteForm"
              :listReasons="listRequoteReasons"
              :action="actionActive"
              :quotationId="idQuotation"
              :dropFiles="dropFiles"
            )
      .column.is-one-third
        quotation-history(
          :events="product.history",
          :code="product.code",
          :quotationId="idQuotation"
        )

        forward-modal(
          :tecnicaQuotation="this.tecnicaQuotation",
          @close="closeModal",
          @forward="handleForward"
        )
        modal-error-service(@close="closeModalError")
</template>
<script>
import { Money } from "v-money";
import SiteConfig from "../services/positiva";
import { getExecutiveList } from "../services/User/executive";
import { getTechnicalList } from "../services/User/technical";
import {
  getProductDataDetail,
  updateProductData,
} from "@/services/services.js";
import { getAdditionalManagement, getRejectReasons } from "../services/Commons";
import Quotation from "../services/QuoteRepository";
import CommentBox from "../components/AppCommentBox.vue";
import AppCommentsViewer from "../components/AppCommentsViewer.vue";
import CommentsRequotes from "../components/CommentsRequotes.vue";
import QuotationHistory from "../components/AppQuotationHistory";
import QuotationActions from "../components/AppQuotationActions";
import ForwardModal from "./modals/ForwardQuotation";
import Reallocation from "../components/Reallocation.vue";
import ModalErrorService from '../views/modals/ErrorService.vue';
import ReasonsRejection from "../components/ReasonsRejection.vue";
import ReasonsRequote from "../components/ReasonsRequote.vue"
import { isExecutive, isTechnical, isBroker, isEmission } from "../mixins/user";
import store from "@/store";
import S3Service from "../services/s3";

const BAG = {
  SOAT_VEHICULAR : 6
}

export default {
  name: "QuotationDetail",
  components: {
    Money,
    CommentBox,
    AppCommentsViewer,
    QuotationHistory,
    QuotationActions,
    ForwardModal,
    Reallocation,
    ReasonsRejection,
    ModalErrorService,
    ReasonsRequote,
    CommentsRequotes
  },
  data() {
    return {
      isLoading: false,
      errs: [],
      product: {
        comment: "",
        comments: {},
      },
      isCommentActive: false,
      isPrimaActive: false,
      isQuotation: false,
      currentInbox: "",
      replyForm: {
        attachment: null,
        text: "",
        observed: false,
        technical_assignee: null,
        premium_currency: "USD"
      },
      dropFiles: [],
      actionActive: "",
      roles: {
        B: "Broker",
        E: "Comercial",
        T: "Técnica",
        R: "Reaseguros",
      },
      tecnicaQuotation: null,
      replyType: null,
      forwardModal: false,
      filteredTags: {},
      idQuotation: null,
      strategicField: false,
      isStrategic: false,
      additionalManagementList: [],
      additionalManagementSelected: [],
      submitButton: true,
      rejectReasons: "",
      labelTextAreaCommentBox: "Comentar",
      listRejectReasons: [],
      listRequoteReasons: [],
      showRejectForm: false,
      showRequoteForm: false,
      fetchIsTechnical: false,
      isValidatedStrategic: false,
      technicalStrategicList: [],
      technicalStrategicSelected: null,
      idDerivationChange: null
    };
  },

  watch: {
    '$route.params.id': {
      immediate: true,
      handler(newValue) {
        this.init(newValue);
      }
    }
    
  },
  async mounted() {

    await this.init(this.$route.params.id);
    this.idQuotation = this.$route.params.id;
    if (isExecutive()) {
      getExecutiveList("team").then((result) => {
        this.filteredTags = result;
      });
      getTechnicalList(`operative/direct-assignees/?team_bag__in=${this.product.technical_team_info.team_bag.id}`).then((result) => {
        this.technicalStrategicList = result.data
        let technicalStrategicListID = result.data.map(team => team.superior_id)
        this.idDerivationChange = technicalStrategicListID[0]
      })
    }
    if (isTechnical()) {
      getTechnicalList("assignable/").then((result) => {
        this.filteredTags = result;
      });
    }

    getAdditionalManagement().then((result) => {
      this.additionalManagementList = result.data;
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.init(to.params.id);
    next();
  },
  computed: {
    dateRejection() {
      let date = new Date(this.product.status_detail.created)
      return date.toLocaleString("en-GB", { hour12: true })
    },
    showSubtitleSuscriptor() {
      if(this.actionActive != 'derive') {
        return this.actionActive != ''
      } else {
        return true
      }
    },
    isPartnership() {
      return this.product.quotation.is_partnership ? "SI" : "NO";
    },

    executive() {
      return isExecutive();
    },

    broker() {
      return isBroker();
    },

    technical() {
      return isTechnical();
    },

    roleEmission() {
      return isEmission();
    },

    managementsDisabled() {
      if (this.currentInbox !== 3) {
        return true;
      }
      return this.executive || this.roleEmission;
    },
  },

  methods: {
    async init(id) {
      await getProductDataDetail(id)
        .then((response) => {
          if (response.status == 200) {
            this.product = response.data;
            this.currentInbox = this.product.history[this.product.history.length - 1].recipient_inbox_id
            this.isStrategic = this.product.is_strategic
            this.isValidatedStrategic = this.product.is_validated_strategic
            this.fetchIsTechnical = this.product.is_technical
            this.additionalManagementSelected =
              this.product.additional_managements
            let comments = this.product.history
            if (comments[comments.length - 1].comment.is_quotation) {
              this.tecnicaQuotation = comments[comments.length - 1].comment
            }
          }
        })
        .catch((error) => {
          this.isLoading = false;
        });
      
    },
    closeModalError(){
      this.$modal.hide('modal-error-service');
      },
    handleTechnicalReject() {
      this.showRejectForm = true
      this.isCommentActive = false
      this.actionActive = "reject"
      this.isPrimaActive = false
      getRejectReasons("reject").then(result => {
        this.listRejectReasons = result.data
      })
    },
    successReallocation() {
      this.init(this.$route.params.id)
    },
    handleSendReply() {
      this.showRejectForm = false
      const loader = this.$buefy.loading.open();
      this.submitButton = false;
      let attachmentIds = [];
      store.state.uploadFiles.map((file) => attachmentIds.push(file.id));
      let data = {
        is_quotation: this.isQuotation,
        action: this.actionActive,
        text: this.replyForm.text,
        attachment_ids: attachmentIds,
        is_strategic: this.isStrategic,
      };
      if (this.isPrimaActive || this.isQuotation) {
        if( this.replyForm.rate == null ) {
          data["rate"] = 0;
        } else data["rate"] = this.replyForm.rate;
        if( this.replyForm.premium == null) {
          data["premium"] = 0
        } else data["premium"] = this.replyForm.premium
        data["premium_currency"] = this.replyForm.premium_currency
      }
      if (this.actionActive == "derive" && this.product.technical_team_info.select_assignee_active) {
        data["technical_assignee"] = this.replyForm.technical_assignee;
      }

      if (this.product.technical_team_info.select_assignee_active && this.product.technical_team_info.team_bag.name == "Multiriesgo e Incendio") {
        data["technical_assignee"] = this.idDerivationChange;
      }

      if (this.product.technical_team_info.select_assignee_active && this.product.technical_team_info.team_bag.name == "Responsabilidad Civil, Deshonestidad, 3D y Robo") {
        data["technical_assignee"] = this.idDerivationChange;
      }
      
      updateProductData(this.product.id, data)
        .then((response) => {
          if (response.status == 200) {
            this.$store.commit("deleteAllUploadCommentFiles");
            this.dropFiles.splice(0, this.dropFiles.length)
            this.$store.commit("clearFilenames");
            loader.close();
            this.submitButton = true;
            this.product = response.data;
            this.$router.push("/quotation/post/confirm");
          }
        })
        .catch(() => {
          loader.close();
          this.isLoading = false;
          this.submitButton = true;
          this.$modal.show("modal-error-service");
        });
    },
    hasEnabledFilter() {
      if (this.actionActive != "derive") {
        return true;
      }
    },
    getStatusClass(statusCode) {
      if (statusCode == 4) return "is-quoted";
      else if (statusCode == 2) return "is-accepted";
      else if (statusCode == 1) return "is-pending";
      else if (statusCode == 5) return "is-rejected";
    },
    handleAccept() {
      this.showRejectForm = false
      this.showRequoteForm = false
      this.isCommentActive = true;
      this.isPrimaActive = false;
      this.actionActive = "accept";
    },
    handleReplyBroker() {
      this.showRejectForm = false
      const existPremium = this.product.history.some( eHistory => {
          if (eHistory.comment) {
            if (eHistory.comment.premium) {
              return true
            }
          }
        })
      existPremium? this.isPrimaActive = false : this.isPrimaActive = true
      this.strategicField = false
      this.isCommentActive = true
      this.actionActive = "quote"
      this.labelTextAreaCommentBox = "COMENTAR (*)"
    },
    handleReplyExecutive() {
      this.showRejectForm = false
      this.isCommentActive = true;
      this.actionActive = "reply";
    },
    handleDesist() {
      this.showRequoteForm = false
      this.isPrimaActive = false;
      this.isCommentActive = false
      this.showRejectForm = true
      this.actionActive = "desist";
      getRejectReasons("desist").then(result => {
        this.listRejectReasons = result.data
      })
    },
    handleComment(data) {
      this.showRejectForm = false
      this.isCommentActive = true;
      this.isPrimaActive = false;
      this.actionActive = "comment";
      this.isQuotation = false;
      this.labelTextAreaCommentBox = "COMENTAR (*)"
    },
    handleReply() {
      this.showRejectForm = false
      this.isCommentActive = true;
      this.isPrimaActive = false;
      this.actionActive = "reply";
      this.isQuotation = false;
      this.replyType = "reply";
      this.labelTextAreaCommentBox = "COMENTAR (*)"
    },
    handleQuote() {
      this.showRejectForm = false
      this.strategicField = false;
      this.isCommentActive = true;
      this.isPrimaActive = true;
      this.actionActive = "quote";
      this.replyType = "quotation";
      this.labelTextAreaCommentBox = "COMENTAR (*)"
    },
    handleRequote() {
      this.showRejectForm = false
      this.showRequoteForm = true
      this.isCommentActive = false
      this.actionActive = "requote"
      this.isPrimaActive = false
      getRejectReasons("requote").then(result => {
        this.listRequoteReasons = result.data
      })
    },
    handleQuoteTecnica() {
      this.showRejectForm = false
      this.isQuotation = true;
      this.isCommentActive = true;
      this.isPrimaActive = true;
      this.actionActive = "reply";
      this.replyType = "quotation";
      this.labelTextAreaCommentBox = "COMENTAR (*)"
    },
    handleReject() {
      this.isPrimaActive = false;
      this.isCommentActive = false
      this.showRejectForm = true
      this.actionActive = "reject";
      getRejectReasons("reject").then(result => {
        this.listRejectReasons = result.data
      })
    },
    handleDerive() {
      this.showRejectForm = false
      this.strategicField = true;
      this.isCommentActive = true;
      this.isPrimaActive = false;
      this.actionActive = "derive";
      this.labelTextAreaCommentBox = "COMENTAR (*)"
    },
    handleForward(comment) {
      const loader = this.$buefy.loading.open();
      this.showRejectForm = false
      // let attachmentIds = []
      // this.tecnicaQuotation.attachments.forEach( attachment => {
      //   attachmentIds.push(attachment.id)
      // })
      let data = {
        is_quotation: this.tecnicaQuotation.is_quotation,
        action: "quote",
        text: comment,
        // attachment_ids: attachmentIds,
        prima: this.tecnicaQuotation.prima,
      };
      if( this.tecnicaQuotation.rate == null ) {
          data["rate"] = 0;
        } else data["rate"] = this.tecnicaQuotation.rate;
      if( this.tecnicaQuotation.premium == null) {
        data["premium"] = 0
      } else data["premium"] = this.tecnicaQuotation.premium
      data["premium_currency"] = this.tecnicaQuotation.premium_currency
      updateProductData(this.product.id, data)
      
        .then((response) => {
          loader.close();
          if (response.status == 200) {
            this.product = response.data;
            this.$router.push("/quotation/post/confirm");
          }
        })
        .catch((error) => {
          loader.close();
          this.isLoading = false;
        });
    },
    handleSuscriptorSelect() {
      this.submitButton = true
    },
    changeActionButton() {
      this.replyForm.text = ""
      this.dropFiles= []
      this.$store.commit("deleteAllUploadCommentFiles");
      this.$store.commit("clearFilenames");
    },
    showModal() {
      this.$modal.show("forward-modal");
    },
    closeModal() {
      this.$modal.hide("forward-modal");
    },
    getTotalFiles: (fields) => {
      if (fields)
        return fields.filter((f) => f.field_type == "file" && f.value).length;
      else return 0;
    },
    showFileName(name) {
      return SiteConfig.showFileName(name, 15, 8);
    },
    parseFieldValue(field) {
      if (field.field_type == "toggle" && field.value)
        return field.value == "True" ? "si" : "no";
      else if (field.field_type == "switch" && field.value)
        return field.value == "True" ? "A Técnica" : "Mi bandeja";
      else if (field.field_type == "select")
        return field.display_value
      else if (field.field_type == "rate")
        return field.display_value ? field.display_value + '%' : "-"
      else if (field.field_type == "technical")
        return field.display_value
      else if (field.field_type == "radio")
        return field.display_value
      else return field.value;
    },
    isFileField(field) {
      let isFile =
        field.field_type == "file" &&
        field.value != null
      return isFile;
    },
    isMultifileField(field) {
      let isFile =
        field.field_type == "multifile" &&
        field.attachments != null
      return isFile;
    },
    changeCheckbox(id, name) {
      const body = {
        additional_management_id: id,
        state: this.$refs[name]["0"].$refs.input.checked,
      };
      Quotation.additionalManagement(this.product.id, body);
    },
    getTasa(rate) {
      this.replyForm['rate'] = parseFloat(rate/100).toFixed(7)
    },
    getPrima(premium) {
      this.replyForm['premium'] = premium
    },
    downloadFile(field) {
      S3Service.getQuotationFieldAttachment(field.id).then((response) => {
        const { url } = response.data;
        var element = document.createElement("a");
        element.setAttribute("href", url);
        element.setAttribute("target", "_blank");
        element.style.display = "none";
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      });
    },
  },
}
</script>


<style lang="scss" scoped>
@import "../assets/scss/breakpoints.scss";
.header-wrapper {
  flex-direction: column;
  text-align: center;
}
.heading {
  font-weight: bold;
}
.margin-title {
  margin-bottom: 26px;
}
.title-column {
  padding-left: 0;
  padding-bottom: 24px;
}
.title {
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  font-family: 'mirairegular';
  margin-bottom: 5px !important;
  margin-right: 70px;
  @include desktop {
    text-align: left;
  }
}
.title-status-wrapper {
  display: flex;
  align-items: center;
}
.assigned {
  margin-bottom: 40px;
}
.subtitle {
  font-size: 16px;
  font-weight: bold;
  font-family: 'mirairegular';
}
.tag {
  @include since-tablet {
  }
}
.c-form__form-row {
  @include mobile {
    min-width: 100%;
  }
}
.product-detail {
  padding: 1rem;
}
.checkbox-wrapper {
  display: flex;
  padding: 0 10px;
  width: 100%;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.subtitle-wrapper {
  padding: 0 10px;
  margin-bottom: 10px;
}
.tasaWrapper {
  padding: 0 10px;
  margin-bottom: 10px;
}
.labelTasa {
  margin-right: 10px;
}
.subtitle-suscriptor {
  color: #7A7A7A;
  padding-left: 10px;
}
.footer-reason {
  display: flex;
  justify-content: space-between
}
.box-wrapper {
  background: #FEF0E6;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 16px;
  margin-bottom: 40px;
}
.title-rejection {
  font-size: 18px;
  color: #F76707;
  font-weight: bold;
  margin-bottom: 16px;
}
.reason-title {
  font-weight: bold;
}
.description-wrapper {
  margin-bottom: 16px;
}

.broker-assigned {
  margin-bottom: 20px;
}

.other-quotation{
  margin-top: 5px;
}

.product-detail-cell{
  margin-bottom: 10px;
}

.product-detail-cell:last-child{
  margin-bottom: 0;
}

</style>
